import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { PerformanceReviewerStrategiesStrategyEnum } from 'generated/resources/graphql'

import { useFormContext } from 'modules/core/hooks/useForm'

import type { Form } from 'modules/performance_process/components/score_configuration_weights/ScoreWeightsSidepanel'
import { type MappedStrategyQuestionnaire } from 'modules/performance_process/hooks/useMappedQuestionnaires'
import { useSectionWeights } from 'modules/performance_process/hooks/useStrategiesScoreConfiguration'

import { EmptyState } from '../EmptyState'
import { SectionWeightItem } from './SectionWeightItem'

type Props = {
  strategy: PerformanceReviewerStrategiesStrategyEnum
  questionnaire: MappedStrategyQuestionnaire
}

export const SectionWeightsList: React.FC<Props> = ({ strategy, questionnaire }) => {
  const form = useFormContext<Form>()
  const configuration = form.values.configurationByStrategy[strategy]

  const weights = configuration?.sectionWeights || []
  const { sections, sectionWeights, isSectionWeightable } = useSectionWeights({
    questionnaire: questionnaire,
    weights: weights,
  })

  const handleWeightChange = (sectionId: string, newWeight: number) => {
    const newSectionWeights = Object.entries(sectionWeights)
      .filter(([id]) => {
        return isSectionWeightable(id)
      })
      .map(([id, weight]) => ({
        sectionId: id,
        weight: id === sectionId ? newWeight : weight,
      }))
    form.setFieldValue(`configurationByStrategy.${strategy}`, {
      ...configuration,
      sectionWeights: newSectionWeights,
    })
  }

  return !!sections.length ? (
    <Box flexDirection="column" gap="s12">
      {sections.map((section) => (
        <SectionWeightItem
          key={`${strategy}-${section.uuid}`}
          section={section}
          weight={sectionWeights[section.uuid]}
          weightable={isSectionWeightable(section.uuid)}
          onChange={handleWeightChange}
        />
      ))}
    </Box>
  ) : (
    <EmptyState />
  )
}
